import React from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';

export default function Contact() {
  return (
    <section id="تواصل-معنا" className="pt-32 pb-24 min-h-screen relative overflow-hidden flex items-center">
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-neon-purple/10 rounded-full blur-[150px] pointer-events-none"></div>
      <div className="container mx-auto px-6 text-center z-10 relative">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto glass-panel p-12 rounded-[2.5rem] border-t border-white/20"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">هل لديك استفسار؟</h2>
          <p className="text-gray-400 mb-10 text-lg">تواصل مع إدارة المقاطعة لأي مساعدة أو لتقديم الاقتراحات.</p>
          <form className="flex flex-col gap-6" onSubmit={(e) => e.preventDefault()}>
            <input type="text" placeholder="الاسم الكريم" className="w-full bg-black/50 border border-white/10 rounded-xl px-6 py-4 text-white focus:outline-none focus:border-neon-cyan focus:shadow-neon transition-all" />
            <input type="text" placeholder="اسمك في الديسكورد (اختياري)" className="w-full bg-black/50 border border-white/10 rounded-xl px-6 py-4 text-white focus:outline-none focus:border-neon-purple focus:shadow-neon-purple transition-all" />
            <textarea placeholder="كيف يمكننا مساعدتك؟" rows="4" className="w-full bg-black/50 border border-white/10 rounded-xl px-6 py-4 text-white focus:outline-none focus:border-neon-cyan focus:shadow-neon transition-all"></textarea>
            <button className="w-full bg-gradient-to-r from-neon-cyan to-neon-purple text-white font-bold py-4 rounded-xl hover:opacity-90 hover:scale-[1.02] active:scale-95 flex items-center justify-center gap-3 transition-all duration-300">
              <span>إرسال الرسالة</span>
              <Send size={20} />
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
}